import { ITournamentFeedResponse } from "@finbackoffice/websocket-client";
import { forwardRef, memo, useContext } from "react";
import LiveTournament from "../../tournament/LiveTournament";
import { LiveCategoriesContext } from "./LiveCategories";
import styles from "./live-categories.module.sass";

type IProps = {
    tournaments: ITournamentFeedResponse[];
    sportId: number;
    showArrow?: boolean;
};

const LiveTournamentsContainer = forwardRef<HTMLDivElement, IProps>(
    ({ tournaments, sportId, showArrow }, ref) => {
        const { feedRid, isTwoColumns, gameLayout, variant } = useContext(LiveCategoriesContext);

        return (
            <div ref={ref} className={styles.container}>
                {tournaments &&
                    tournaments.map((tournament) => (
                        <LiveTournament
                            key={tournament.id}
                            tournament={tournament}
                            sportId={sportId}
                            openedByDefault
                            showArrow={showArrow}
                            feedRid={feedRid}
                            isTwoColumns={isTwoColumns}
                            gameLayout={gameLayout}
                            variant={variant}
                        />
                    ))}
            </div>
        );
    },
);

export default memo(LiveTournamentsContainer);
